export default "__VITE_ASSET__BckL3KDr__"